/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { update } from '../../services/item';
import { saveAll } from '../../store/items';
import {
  SettingsIconButton,
  SettingsInput,
  SettingsStaticValue,
} from '../form/settings.Widget';

export const ItemSettingsInputEditable = props => {
  const { itemId, type, initValue } = props;

  const item = useSelector(state => state.items[initValue]);
  const dispatch = useDispatch();

  const [edit, setEdit] = useState(false);
  const isValidObjectId = value =>
    typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);

  const handleBlur = value => {
    setEdit(false);
    update(`items/${itemId}`, type, value);
  };

  const getItem = async itemId => {
    if (!isValidObjectId(itemId)) {
      return;
    }
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/items/${itemId}`
    );

    if (res.data?._id) {
      dispatch(saveAll({ item: res.data }));
    }
  };

  useEffect(() => {
    if (!item && isValidObjectId(initValue)) {
      getItem(initValue);
    }
  }, [initValue, item]);

  return (
    <div className='flex-1 flex items-center gap-05'>
      {edit ? (
        <SettingsInput
          initValue={initValue}
          onBlur={value => handleBlur(value)}
        />
      ) : (
        <SettingsStaticValue className='flex-1'>
          {item?.label ?? initValue ?? '—'}
        </SettingsStaticValue>
      )}
      <SettingsIconButton
        onClick={() => setEdit(!edit)}
        className={`${
          edit ? 'text-primary' : 'text-contrast opacity-50'
        }`}
      >
        <FaEdit />
      </SettingsIconButton>
    </div>
  );
};
